import _ from "lodash"

const getVariant = (product, option) => {
  if (!option) return product.variants.nodes[0]

  const matched = []
  /*eslint-disable*/
  const selectedOption = _.filter(product.variants.nodes, function (variant) {
    /*eslint-enable*/
    return _.some(variant.selectedOptions, function (varaintOption) {
      if (
        option.name === varaintOption.name &&
        option.value === varaintOption.value
      ) {
        matched.push(variant)
      }
      return
    })
  })
  return matched[0]
}

export { getVariant }
